module.exports = __webpack_public_path__ + "static/media/v2.1.c3eba86c.pdf";